import {Component, OnInit} from "@angular/core";
import * as moment from "moment-timezone";
import {Names} from "../names";
import {AppNavigationService} from "@nordpoolgroup/nps-angular-2-common";
import {BrandingService} from "@nordpoolgroup/nps-angular-2-common";
import {AuthorizationService} from "@nordpoolgroup/nps-angular-2-common";
import {UserService} from "@nordpoolgroup/nps-angular-2-common";
import {GlobalService} from "@nordpoolgroup/nps-angular-2-common";
import {MomentPipe} from "@nordpoolgroup/nps-angular-2-common";


@Component({
    selector: Names.applicationBar.selector,
    template: require("./applicationBar.html")
})
export class ApplicationBarComponent implements OnInit {
    currentUser: NPS.Common.IUser;
    rejectedReportsCount: number;
    time: string;
    timeZone: string;
    applicationBarLogoUrl: string;
    isFullHeightLogo = false;
    private timeZoneIdentifier = "Europe/Oslo";
    private pageTitle = "NPS - Contract Management UI";

    private timeUpdateIntervalId: number;
    private systemConfiguration: NPS.Common.Branding.ISystemConfiguration;

    constructor(
        private globalService: GlobalService,
        private userService: UserService,
        private authorizationService: AuthorizationService,
        private appNavigationService: AppNavigationService,
        private brandingService: BrandingService) {

        this.brandingService.updateDocumentTitle(this.pageTitle);
        this.systemConfiguration = this.brandingService.getSystemConfiguration();

        // Work around https://github.com/angular/angular.js/issues/7103
        this.timeUpdateIntervalId = setInterval(this.tick.bind(this), 1000);

        this.currentUser = this.userService.user;

        this.getLogUrlForCurrentTenant();
        this.updateTime();
    }

    ngOnInit() {
        this.appNavigationService.initialise();
    }

    logout() {
        this.authorizationService.logout();
    }

    private updateTime(): void {
        const timeInTimeZone: moment.Moment = this.currentDateTime;
        this.time = MomentPipe.staticTransform(timeInTimeZone, "HH:mm");
        this.timeZone = timeInTimeZone.format("z");
    }

    private tick(): void {
        this.updateTime();
    }

    private onDestroy(): void {
        if (this.timeUpdateIntervalId !== undefined) {
            clearInterval(this.timeUpdateIntervalId);
            this.timeUpdateIntervalId = undefined;
        }
    }

    get currentDateTime(): moment.Moment {
        return moment
            .utc()
            .tz(this.timeZoneIdentifier);
    }

    private getLogUrlForCurrentTenant() {
        const tenantId: string = this.userService.user.availableTenants[0];
        if (tenantId === "N") {
            this.applicationBarLogoUrl = "/assets/images/logo-nord-pool.svg";
        } else if (tenantId === "A") {
            this.applicationBarLogoUrl = "/assets/images/logo-cropex.svg";
        } else if (tenantId === "B") {
            this.applicationBarLogoUrl = "/assets/images/logo-ibex.svg";
        } else if (tenantId === "D") {
            this.applicationBarLogoUrl = "/assets/images/logo-genex.svg";
        } else if (tenantId === "E") {
            this.applicationBarLogoUrl = "/assets/images/logo-brm.svg";
        } else if (tenantId === "F") {
            this.applicationBarLogoUrl = "/assets/images/logo-elma.svg";
        } else if (tenantId === "H") {
            this.applicationBarLogoUrl = "/assets/images/logo-enexgroup.svg";
            this.isFullHeightLogo = true;
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/ApplicationBar/ApplicationBarComponent.ts